ArchivedModelView = require 'views/archive/archived-model-view'
Controller = require 'controller'
View = require 'view'
templates = require 'views/internal/templates'
FreeTeamsOutOfSpaceBanner = require('common/components/closed-boards-dialog/free-teams-out-of-space-banner').default
FreeTeamsOutOfSpacePopOver = require('common/components/closed-boards-dialog/free-teams-out-of-space-popover').default
PopOver = require 'views/lib/pop-over'
React = require 'react'
ReactDOM = require 'react-dom'
l = require 'lib/localize'
{ featureFlagClient } = require 'common/lib/feature-flag-client'
ModelLoader = require 'db/model-loader'
f = require 'effing'
_ = require 'underscore'

module.exports = class ClosedBoardsView extends View

  initialize: ->
    @isBoardLimitsFeatureOn = featureFlagClient.get('bc.board_limits', false)
    featureFlagClient.on 'bc.board_limits', @onLDFlagChange
    @listenTo @model.boardList,
      'change:closed add remove reset': @frameDebounce @render

    ModelLoader.loadOrgMemberLimits().done()

  onLDFlagChange: (isFeatureOn) =>
    @isBoardLimitsFeatureOn = isFeatureOn
    @render()

  remove: ->
    featureFlagClient.off 'bc.board_limits', @onLDFlagChange

  render: ->
    boards = @model.boardList
    @closedBoards = boards.filter((entry) -> entry.get('closed'))
    data =
      empty: @closedBoards.length == 0

    @$el.html(
      templates.fill(
        'closed_boards',
        data
      )
    )

    $list = @$('.js-archive-items')

    @removeSubviews()
    subviews = boards.sortBy((board) -> board.get('name').toUpperCase()).filter(f.method('get', 'closed')).map (model) =>
      @subview ArchivedModelView, model,
        onReopen: @onReopen.bind(@)
        reOpenText: l('unarchive board')
        reopenDisabled: @isBoardLimitsFeatureOn && model.isOrgAtOrOverFreeBoardLimit()

    @appendSubviews subviews, $list

    @renderFreeTeamsOutOfSpaceBanner()
    @

  onReopen: (board) -> Controller.displayBoard({ idBoard: board.id }).done()

  renderFreeTeamsOutOfSpaceBanner: ->
    freeOrgsAtOrOverFreeLimit = _.chain(@model.boardList.models)
      .filter (board) =>
        idOrg = board.get('idOrganization')
        canReopen = if board.owned? then board.owned() else board.editable()
        idOrg && board.get('closed') && canReopen
      .map (board) =>
        _.find @model.organizationList.models, (org) ->
          org.id == board.get('idOrganization') && !org.isPremium() && org.isAtOrOverFreeBoardLimit()
      .compact()
      .unique()
      .value()
    if @isBoardLimitsFeatureOn && freeOrgsAtOrOverFreeLimit.length > 0
      props =
        freeTeamCount: freeOrgsAtOrOverFreeLimit.length
        onTeamCountClick: => @renderFreeTeamsOutOfSpacePopover(freeOrgsAtOrOverFreeLimit)
      Element = React.createElement FreeTeamsOutOfSpaceBanner, props
      @reactRoot = @$('.js-free-teams-out-of-space-banner')[0]
      ReactDOM.render Element, @reactRoot

  renderFreeTeamsOutOfSpacePopover: (orgs) ->
    props =
      key: 'FreeTeamsOutOfSpacePopover'
      teams: orgs.map (org) ->
        name: org.get('displayName')
        upgradeUrl: "/#{org.get('name')}/billing"
    PopOver.show
      reactElement: React.createElement FreeTeamsOutOfSpacePopOver, props
      elem: @reactRoot
      getViewTitle: -> l('free teams out of space popover')




// WEBPACK FOOTER //
// ./app/scripts/views/archive/closed-boards-view.coffee